module.exports = __webpack_public_path__ + "img/p2-p2-yanzi.86e9446c.png";